var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52876 3.52851C3.78911 3.26816 4.21122 3.26816 4.47157 3.52851L8.00016 7.05711L11.5288 3.52851C11.7891 3.26816 12.2112 3.26816 12.4716 3.52851C12.7319 3.78886 12.7319 4.21097 12.4716 4.47132L8.94297 7.99992L12.4716 11.5285C12.7319 11.7889 12.7319 12.211 12.4716 12.4713C12.2112 12.7317 11.7891 12.7317 11.5288 12.4713L8.00016 8.94273L4.47157 12.4713C4.21122 12.7317 3.78911 12.7317 3.52876 12.4713C3.26841 12.211 3.26841 11.7889 3.52876 11.5285L7.05735 7.99992L3.52876 4.47132C3.26841 4.21097 3.26841 3.78886 3.52876 3.52851Z",
    fill: "#4C4A4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.563cc31e2343610c23f1fff744640788.svg";
export { ForwardRef as ReactComponent };